import { forwardRef } from 'react';
import type React from 'react';
import SvgIcon from '~/styles/SvgIcon';

type OwnProps = React.SVGProps<SVGSVGElement>;

const Check = forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <SvgIcon ref={ref} {...props}>
    <g>
      <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
    </g>
  </SvgIcon>
));

export default Check;
